import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AuthenticationService } from '../../services/base/authentication.service';
import { Domain, Organisation } from '../../interfaces/routering/organisation';

@Component({
  selector: 'fury-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {

  @Output() openSidenav: EventEmitter<any> = new EventEmitter();

  public webformUrlExists: boolean = false;

  constructor(private authenticationService: AuthenticationService) {
  }

  ngOnInit(): void {
    this.authenticationService.organisation$.subscribe((organisation: Organisation): void => {
      this.webformUrlExists = organisation.domains.some((domain: Domain): boolean => domain.type.name === 'webform');
    });
  }
}
